import * as React from "react";

import { Button } from "@/components/shadcn/button.tsx";
import {
  Dialog,
  DialogContent,
  DialogDescription, DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/shadcn/dialog.tsx";
import { useTranslation } from "react-i18next";
import { constants } from "@/constants";
import {alertError, alertSuccess} from "@/utils/utils.ts";
import { Input } from "@/components/shadcn/input.tsx";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { queryKey } from "@/store/queryKeys.ts";
import {Icon} from "@/components/Icon.tsx";

export const EditRefCodeModal = ({ refCode }: { refCode: string }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");

  async function saveValue(val: string) {
    try {
      let url = `${constants.url.API_PREFIX}billing/partner`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ref_code: val,
        }),
      });

      let respData = await response.json();
      if (respData.error_code) {
        alertError(t(respData.error_code));
        return;
      } else {
        alertSuccess(t("saved"))
        setOpen(false);
      }

      queryClient.invalidateQueries(queryKey.partner);
      alertSuccess()
    } catch (e) {
      alertError(t("alerts.default_error_message"));
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" className="[&_svg]:size-5">
          <Icon icon="fluent:edit-24-regular" />
          Изменить ссылку
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Уникальная ссылка</DialogTitle>
          <DialogDescription>
            Придумайте броское и уникальное имя, которое ваша аудитория легко
            запомнит
          </DialogDescription>
        </DialogHeader>
        <Input
          type="promocode"
          onChange={(e: any) => {
            if (e.target.value.length < 20) {
              setCode(e.target.value.replace(/[^a-zA-Z0-9_-]/g, ""));
            }
          }}
          placeholder={refCode}
        />

        <Button
          disabled={code == ""}
          variant="default"
          onClick={() => {
            saveValue(code);
          }}
        >
          {t("save")}
        </Button>
        <DialogFooter><b>При изменении ссылки предыдущая ссылка перестанет работать.</b></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
